import Link from "@/v2-backoffice-client/components/link"
import FeatureNotice from "@/v2-backoffice-client/feature/FeatureNotice"
import type { ConfigurationOwner } from "@/v2-backoffice-client/feature/configuration/feature.configuration.types"

export type FeatureConfigurationElsewhereProps = {
  className?: string
  featureCode: string
  owner: ConfigurationOwner
}

/**
 * Sends the operator to the catalog that actually holds this feature's
 * configuration. A generic JSON editor here would write
 * common.Features.Configuration, which for these types nothing reads.
 */
function FeatureConfigurationElsewhere(
  props: FeatureConfigurationElsewhereProps,
) {
  const { featureCode, owner, className } = props

  return (
    <FeatureNotice tone="info" className={className}>
      Configured as a {owner.label}, not as a plain feature. Its settings live
      in the {owner.label} catalog, with an editor built for them —{" "}
      <Link
        to={owner.getHref(featureCode)}
        size="xs"
        data-feature-code="UI_BackofficeFeatures_Configuration_OwnerLink"
      >
        open {featureCode}
      </Link>
      .
    </FeatureNotice>
  )
}

export default FeatureConfigurationElsewhere
